import { ModelEntityType } from '@upright/common/model/input/types';
import { useNetImpactLensContext } from '@upright/ui/common/upright/core/impact-lenses/net-impact/common/use-net-impact-lens-context';
import { WeightSetItemContributionsList } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/contributors/contributing-items';
import { CompanyContributingProductList } from '@upright/ui/common/upright/core/impact-lenses/net-impact/info-boxes/single-impact/contributors/contributing-products';

export function SingleImpactContributors() {
  const ctx = useNetImpactLensContext();
  const entityType = ctx?.data?.entity?.type;
  if (entityType === ModelEntityType.COMPANY) {
    return <CompanyContributingProductList />;
  } else if (entityType === ModelEntityType.PORTFOLIO || entityType === ModelEntityType.GROUP) {
    return <WeightSetItemContributionsList />;
  }
  return <></>;
}
